import { Box, CircularProgress } from "@mui/material";
import { observer } from "mobx-react-lite";
import AuthStore from "../stores/AuthStore";
import { useCartStore } from "../stores/CartStore";

const GlobalLoading = observer(() => {
    const cartStore = useCartStore();

    if (AuthStore.loading || cartStore?.loading) {
        return (
            <Box
                sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 9999,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <CircularProgress size={75} />
            </Box>
        );
    }
    return null;
});

export default GlobalLoading;
